import React from "react";
import Slider from "react-slick";
import styles from "./CategoryCarousel.module.scss";
import CategoryBox from "../CategoryItens/CategoryBox/CategoryBox";
import "../../global.scss";
import swipe from "assets/img/iconTop.png";

class CategoryCarousel extends React.Component {
    filtrarEstabelecimentos = (searchstring, categoria = null, subcategoria = null)  => {
        this.props.filtrar(searchstring, categoria, subcategoria);
        this.props.setSelectedMkr(null);
    };
    
    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 200,
            slidesToShow: 3,
            rows: 1,
            swipeToSlide: true,
            responsive: [
                {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5
                }
                },
                {
                breakpoint: 780,
                settings: {
                    slidesToShow: 4
                }
                },
                {
                breakpoint: 580,
                settings: {
                    slidesToShow: 3
                }
                }
            ]
        };

        const { categorias } =  this.props;

        return (
            <div className={styles.categoryFilter}>
                <h2 className={styles.title}>Categorias</h2> <img
                        alt="Swipe"
                        className="swipe"
                        src={swipe}
                    />
                <Slider {...settings}>
                    {  categorias && categorias.length > 0 ? categorias.map(categoria => 
                        <CategoryBox
                            categoria={categoria}
                            filtrar={this.filtrarEstabelecimentos}
                            selectedMkr={this.props.selectedMkr}
                            setZoom={this.props.setZoom}   
                            setIsSeenOnMap={this.props.setIsSeenOnMap}
                            key={categorias}
                            setFilterText={this.props.setFilterText}
                        />
                    ) : null }
                </Slider>
            </div>
        );
    }
}
export default CategoryCarousel;